// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuestionsCarousel-module__questionsNavigationWrapper {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  padding: 10px 0px;
}

.QuestionsCarousel-module__embla {
  overflow: hidden;
  flex: 1;
}

.QuestionsCarousel-module__emblaContainer {
  display: flex;
  gap: 14px;
  height: 48px;
}

.QuestionsCarousel-module__emblaSlide {
  flex: 0 0 auto;
  min-width: 0;
}

.QuestionsCarousel-module__chevronIcons {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
}

.QuestionsCarousel-module__chevronIcons img {
  width: 22px;
  height: 22px;
}

.QuestionsCarousel-module__questionIndicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  opacity: 1;
  position: relative;
  border-radius: 5px;
  padding-top: 6px;
  padding-right: 11px;
  padding-bottom: 6px;
  padding-left: 11px;
  gap: 10px;
  border: 1px solid #b8c2cc;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  line-height: 100%;
  color: #6e7191;
}

.QuestionsCarousel-module__questionIndicator.QuestionsCarousel-module__answeredAndSelected {
  border: 2px solid #00354e;
  background-color: #00354e;
  color: #fcfcfc;
}

.QuestionsCarousel-module__questionIndicator.QuestionsCarousel-module__answered {
  border: 2px solid #3c8dcb;
  background-color: #3c8dcb;
  color: #fcfcfc;
}

.QuestionsCarousel-module__questionIndicator.QuestionsCarousel-module__selected {
  border: 2px solid #00354e;
  color: #00354e;
}

.QuestionsCarousel-module__questionIndicator img {
  position: absolute;
  width: 11.7px;
  height: 8.5px;
  opacity: 1;
  top: 3.75px;
  right: 1.66px;
}
`, "",{"version":3,"sources":["webpack://./src/components/evaluation/QuestionsCarousel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,UAAU;EACV,WAAW;EACX,aAAa;AACf","sourcesContent":[".questionsNavigationWrapper {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  padding: 10px 0px;\n}\n\n.embla {\n  overflow: hidden;\n  flex: 1;\n}\n\n.emblaContainer {\n  display: flex;\n  gap: 14px;\n  height: 48px;\n}\n\n.emblaSlide {\n  flex: 0 0 auto;\n  min-width: 0;\n}\n\n.chevronIcons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background: transparent;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.chevronIcons img {\n  width: 22px;\n  height: 22px;\n}\n\n.questionIndicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px !important;\n  height: 48px !important;\n  min-width: 48px !important;\n  opacity: 1;\n  position: relative;\n  border-radius: 5px;\n  padding-top: 6px;\n  padding-right: 11px;\n  padding-bottom: 6px;\n  padding-left: 11px;\n  gap: 10px;\n  border: 1px solid #b8c2cc;\n  background-color: #ffffff;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 100%;\n  color: #6e7191;\n}\n\n.questionIndicator.answeredAndSelected {\n  border: 2px solid #00354e;\n  background-color: #00354e;\n  color: #fcfcfc;\n}\n\n.questionIndicator.answered {\n  border: 2px solid #3c8dcb;\n  background-color: #3c8dcb;\n  color: #fcfcfc;\n}\n\n.questionIndicator.selected {\n  border: 2px solid #00354e;\n  color: #00354e;\n}\n\n.questionIndicator img {\n  position: absolute;\n  width: 11.7px;\n  height: 8.5px;\n  opacity: 1;\n  top: 3.75px;\n  right: 1.66px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"questionsNavigationWrapper": `QuestionsCarousel-module__questionsNavigationWrapper`,
	"embla": `QuestionsCarousel-module__embla`,
	"emblaContainer": `QuestionsCarousel-module__emblaContainer`,
	"emblaSlide": `QuestionsCarousel-module__emblaSlide`,
	"chevronIcons": `QuestionsCarousel-module__chevronIcons`,
	"questionIndicator": `QuestionsCarousel-module__questionIndicator`,
	"answeredAndSelected": `QuestionsCarousel-module__answeredAndSelected`,
	"answered": `QuestionsCarousel-module__answered`,
	"selected": `QuestionsCarousel-module__selected`
};
export default ___CSS_LOADER_EXPORT___;
